import { z } from 'zod';

const urlList = z.array(z.url()).max(50);

export const oauthClientAppTypeSchema = z.enum(['regular_web', 'spa']);
export type OauthClientAppTypeDTO = z.infer<typeof oauthClientAppTypeSchema>;

export const oauthClientDTOSchema = z.object({
  id: z.string(),
  auth0Id: z.string(),
  displayName: z.string(),
  description: z.string().nullable(),
  appType: oauthClientAppTypeSchema,
  callbackUrls: urlList,
  allowedLogoutUrls: urlList,
  webOrigins: urlList,
  createdAt: z.string(),
});

export const oauthClientArrayDTOSchema = z.array(oauthClientDTOSchema);

export const oauthClientCreateDTOSchema = z.object({
  displayName: z.string().min(1).max(120),
  description: z.string().max(500).optional(),
  appType: oauthClientAppTypeSchema,
  callbackUrls: urlList.optional(),
  allowedLogoutUrls: urlList.optional(),
  webOrigins: urlList.optional(),
});

export const oauthClientUpdateDTOSchema = z.object({
  displayName: z.string().min(1).max(120).optional(),
  description: z.string().max(500).nullable().optional(),
  callbackUrls: urlList.optional(),
  allowedLogoutUrls: urlList.optional(),
  webOrigins: urlList.optional(),
});

export const oauthClientWithSecretDTOSchema = oauthClientDTOSchema.extend({
  clientSecret: z.string(),
});
